var _path, _path2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedicinebottle = function SvgMedicinebottle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M16.657 14.134V12.75h.915V9.925H6.6v2.825h.914v1.384H5v16.228a3.05 3.05 0 0 0 3.053 3.052h11.12v-19.28z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M17.572 6.684v3.24H6.6v-3.24L8.49 2h7.195z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "medicinebottle_svg__a",
    width: 26,
    height: 33,
    x: 5,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 33.414h25.437V2H5z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#medicinebottle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M7.514 19.284h3.52v-1.828h-3.52zM7.514 23.057h3.52v-1.829h-3.52zM7.514 26.828h3.52V25h-3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M29.186 33.414h-9.74a2.604 2.604 0 0 1-2.604-2.604v-7.506h12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    d: "M15.591 23.304h14.846v-4.38H15.591z"
  }))));
};
export default SvgMedicinebottle;